import { parseListDate } from "helpers/parseListDate";
import { SupplierFeedbackRow } from "./SupplierFeedbackList.types";

export const formatSupplierFeedbackRow = (
  row: SupplierFeedbackRow
): { [K in keyof typeof row]: React.ReactNode } => {
  let formattedRow: any = { ...row };

  if (formattedRow.supplierFeedbackTypes__AddDate) {
    formattedRow = {
      ...formattedRow,
      supplierFeedbackTypes__AddDate: parseListDate(
        formattedRow.supplierFeedbackTypes__AddDate,
        true
      ),
    };
  }
  if (formattedRow.supplierFeedbackTypes__EditDate) {
    formattedRow = {
      ...formattedRow,
      supplierFeedbackTypes__EditDate: parseListDate(
        formattedRow.supplierFeedbackTypes__EditDate,
        true
      ),
    };
  }

  return formattedRow;
};
